// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"6fdaca15","120":"5a749c96","804":"9b203518","956":"3041b34b"}[chunkId] + ".chunk.css";
};